import { spaAppReducer } from "./spa-app-reducer.js";
import { defaultLogger } from "../helper/logger.js";
import { appRouteEffect } from "./spa-app-effects.js";
import { ImmutableStateExtension, LoggerExtension, ReduxDevtoolsExtension, configureStore } from "mini-rx-store";
//#region src/store/mini-rx.store.ts
var store;
var registerEffects = (effects) => {
	if (store) {
		store.effect(appRouteEffect);
		effects.forEach((effect) => store.effect(effect));
	} else defaultLogger.error("Store is not initialized. Cannot register effects.");
};
var initializeStore = (param) => {
	defaultLogger.debug("Initialize Store:", param);
	if (!store) {
		store = configureStore({
			reducers: param.reducer ? {
				spaApp: spaAppReducer,
				...param.reducer
			} : { spaApp: spaAppReducer },
			extensions: [
				new LoggerExtension(),
				new ReduxDevtoolsExtension({ name: param.appName }),
				new ImmutableStateExtension()
			]
		});
		registerEffects(param.effects);
	}
};
var pdStore = () => store;
//#endregion
export { initializeStore, pdStore };
